import { CardContent as MuiCardContent, CardContentProps } from "@mui/material";

export const CardContent = (props: CardContentProps) => {
  const { sx, ...rest } = props;
  return (
    <MuiCardContent
      sx={{
        px: 2,
        py: 3,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        ...sx,
      }}
      {...rest}
    />
  );
};
